/**
 * Test IDs for QA automation.
 */
export const testIds = {
  executionHistoryViewRefresh: "execution-history-view-refresh",
  executionHistoryViewToggleErrorDetails: "execution-history-view-toggle-error-details",
} as const;
